import React from "react";
import { Link } from "react-router-dom";
import { Paper, Typography, Button, Box } from "@mui/material";
import DatasetIcon from "@mui/icons-material/Dataset";
import PredictionIcon from "@mui/icons-material/Analytics";
import ReviewIcon from "@mui/icons-material/RateReview";
import "./QuoteParseEval.css";

const QuoteParseEvalComponent = () => {
    return (
        <Box className="quote-parse-eval">
            <Typography
                variant="h4"
                gutterBottom
                component="div"
                className="quote-parse-eval__title"
            >
                Quote Parse Evaluation
            </Typography>

            <div className="quote-parse-eval__grid">
                <Paper elevation={3} className="quote-parse-eval__paper">
                    <DatasetIcon
                        color="primary"
                        className="quote-parse-eval__icon"
                    />
                    <Typography variant="h5" component="h2" gutterBottom>
                        Dataset
                    </Typography>
                    <Typography
                        variant="body1"
                        className="quote-parse-eval__button-text"
                    >
                        Access and manage your quote parsing dataset
                    </Typography>
                    <Button
                        component={Link}
                        to="/quote_parse_eval/dataset"
                        variant="contained"
                        color="primary"
                        size="large"
                    >
                        View Dataset
                    </Button>
                </Paper>
                <Paper elevation={3} className="quote-parse-eval__paper">
                    <PredictionIcon
                        color="secondary"
                        className="quote-parse-eval__icon"
                    />
                    <Typography variant="h5" component="h2" gutterBottom>
                        Predictions
                    </Typography>
                    <Typography
                        variant="body1"
                        className="quote-parse-eval__button-text"
                    >
                        Review and analyze quote parsing predictions
                    </Typography>
                    <Button
                        component={Link}
                        to="/quote_parse_eval/predictions"
                        variant="contained"
                        color="secondary"
                        size="large"
                    >
                        View Predictions
                    </Button>
                </Paper>
                <Paper
                    elevation={3}
                    className="quote-parse-eval__paper quote-parse-eval__review-module"
                >
                    <ReviewIcon
                        color="action"
                        className="quote-parse-eval__icon"
                    />
                    <Typography variant="h5" component="h2" gutterBottom>
                        Start Review
                    </Typography>
                    <Typography
                        variant="body1"
                        className="quote-parse-eval__button-text"
                    >
                        Begin reviewing and evaluating quotes
                    </Typography>
                    <Button
                        component={Link}
                        to="/quote_parse_eval/review"
                        variant="contained"
                        color="primary"
                        size="large"
                    >
                        Start Reviewing Quotes
                    </Button>
                </Paper>
            </div>
        </Box>
    );
};

export default QuoteParseEvalComponent;
